module.exports = __webpack_public_path__ + "img/maguro-tonijnnigiri.5d6c1c4b.png";